import en from 'vuetify/es5/locale/en'

export default {
  label: 'English',
  //page login
  login: 'Login',
  logIn: 'Log In',
  register: 'Register',
  email: 'Email',
  signup: 'Sign Up',
  password: 'Password',
  mfaCodeDecrypted: 'Verification Code',
  login_account: 'Login account',
  forgotPassword: 'Forgot Password?',
  //password reset
  resetCode: 'Verification Code',
  newPassword: 'New Password',
  newPasswordRepeat: 'New Password (Repeat)',
  //app drawer
  sponsor: 'Sponsor',
  // menu
  menu: {
    suiteAnalyticsConnect: 'SuiteAnalytics Connect',
    internationalShipping: 'International Shipping',
    admin: 'Admin',
    refinery: 'Refinery',
    adminAlerts: `Alerts`,
    adminCategories: 'Order Categories',
    adminCompanies: 'Companies',
    contactUs: 'Contact Us',
    configuration: 'Configuration',
    application: 'Application',
    signup: 'Sign Up',
    shippingInfo: 'Shipping Info',
    resources: 'Resources',
    releases: 'Releases',
    equityTrust: 'DirectLink IRA™ for Equity Trust',
    wireACHInstructions: 'Wire & ACH Instructions',
    preSettlementPaymentProgram: 'Pre-Settlement Payment Program',
    help: 'Help',
    home: 'Home',
    addresses: 'Address Book',
    "Address Book": "Address Book",
    bankInfo: 'Bank Info',
    settings: 'Settings',
    trade: 'Trade',
    dashboard: 'Dashboard',
    orders: 'Orders',
    invoices: 'Invoices',
    limitOrders: 'Limit Orders',
    adminSignup: 'Sign Up Company',
    limitOrder: 'Limit Order',
    salesOrders: 'Sales Orders',
    salesOrder: 'Sales Order',
    orderConfirmation: 'Order Confirmation',
    purchaseOrders: 'Purchase Orders',
    purchaseOrder: 'Purchase Order',
    User: 'User',
    access_denied: 'Access Denied',
    static: 'Static',
    shipSecure: 'ShipSecure',
    shipSecureGuidelines: 'ShipSecure Shipping Guidelines',
    apiDocs: 'API Docs',
    apiFaq: 'API FAQ',
    productDetail: 'Product Detail',
    charts: 'Charts',
    gold: 'Gold',
    silver: 'Silver',
    platinum: 'Platinum',
    palladium: 'Palladium',
    goldSilver: 'Gold/Silver Ratio',
    adminStockAlerts: `Stock Alerts`,
    metalTransactions: `Metal Transactions`,
    accountBalances: 'Account Balances',
    metalWalletDetail: 'Metal Wallet Detail',
    enroll: 'Learn More',
    contracts: 'Contracts',
    createRefiningLot: 'Submit New Refining Lot',
    refiningLots: 'Refining Lots',
    masterLots: 'Master Lots',
    masterLot: 'Master Lot',
    createMasterLot: 'New Master Lot',
    editMasterLot: 'Edit Master Lot',
    receiveRefiningLots: 'Receive Lots',
    assays: 'Draft & Finalized Assays',
    receivedRefiningLots: 'Received Lots',
    refine: 'Refine',
    refiningTerms: 'Refining Terms',
    // "Sign New Terms": 'Sign New Terms',
    cashAdvances: 'Cash Advances',
    settlementBreakdownTest: 'Settlement Breakdown Test',
    onlineNow: 'Users Online',
    adminPermissions: 'Admin Permissions',
  },
  rule: {
    required: 'Your {0} is required',
  },
  //error
  ...en,
}
